import _ from 'lodash'

import riderMessages from 'core/data-model/constants/validation-messages'

export const checkRiderPremiumRule = (rule, eligibilities) => {
  let errorMessage = ''
  const riderPremium =
    eligibilities.modelFactor && eligibilities.modelFactor.periods
      ? eligibilities.rider.premium * eligibilities.modelFactor.periods
      : eligibilities.rider.premium

  if (riderPremium < rule.minimumValue || riderPremium > rule.maximumValue) {
    let messageId = `RULE_RIDER_${eligibilities.rider.code}_PREMIUM`
    errorMessage = _.get(riderMessages, messageId) || riderMessages.RULE_MESSAGE_NOT_FOUND
  }

  return {
    type: rule.validationType,
    message: errorMessage,
  }
}
